/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import moment from 'moment'

import { ViewBy } from '../../../types'
import { viewByFormat } from '../constants'

import type { ReducerState } from '../../Filters/filtersReducer'

export const getPartialMonthSelections = ({
  endDate,
  startDate,
  viewBy,
}: Pick<ReducerState, 'endDate' | 'startDate' | 'viewBy'>): string[] => {
  const months: string[] = []

  if (viewBy === ViewBy.MONTH) {
    if (!startDate.isSame(moment(startDate).startOf('month'), 'day')) {
      months.push(startDate.format(viewByFormat[ViewBy.MONTH]))
    }

    if (!endDate.isSame(moment(endDate).endOf('month'), 'day')) {
      months.push(endDate.format(viewByFormat[ViewBy.MONTH]))
    }
  }

  return months
}
